'use es6';

import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-message-history/senders/operators/getters';
import Sender from 'conversations-message-history/senders/records/Sender';
import { getSenderId, getSenderType } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getFromSenderName, getFromSenderEmail } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { isFromAgent, isFromBot, isFromSystem } from 'conversations-message-history/common-message-format/operators/senderTypeComparators';
import I18n from 'I18n';
export const getDefaultSenderName = message => {
  if (isFromAgent(message)) return I18n.text('conversations-visitor-message-history.agent');
  if (isFromBot(message)) return I18n.text('conversations-visitor-message-history.bot');
  if (isFromSystem(message)) return I18n.text('conversations-visitor-message-history.system');
  return '';
};
export const getSenderFromMessageSenders = (message, senders) => {
  const senderId = getSenderId(message);
  const senderType = getSenderType(message);
  const asyncSender = findSender(senderId, senderType, senders);
  const sender = getData(asyncSender) || Sender({
    senderType,
    firstName: getFromSenderName(message) || getDefaultSenderName(message),
    email: getFromSenderEmail(message) || null
  });
  return sender;
};